import { Alert, MenuItem, TextField } from "@mui/material";
import type { PrepaidAccountingModeEnum, PrepaidOpeningBalanceModeEnum } from "../../../generated/backendClient";
import type { DATEVConfigRecord } from "../../../providers/datevProvider";
import { Column } from "../../../misc/Column";
import { DATEV_PREPAID_EXPORT_LABELS } from "./datevLabels";

const ACCOUNTING_LABELS: Record<PrepaidAccountingModeEnum, string> = {
  LIABILITY: "Auf einem separaten Guthabenkonto",
  DEBTOR_CREDIT: "Direkt auf dem Schülerkonto",
};

const OPENING_LABELS: Record<PrepaidOpeningBalanceModeEnum, string> = {
  BLOCK: "Export bei unbestätigtem Anfangsguthaben sperren",
  EXTERNALLY_RECORDED: "Beim Steuerbüro bereits erfasst",
  EXPORT: "In einem separaten Eröffnungsstapel exportieren",
};

export function DATEVPrepaidSettings(props: { config: DATEVConfigRecord }) {
  const { config } = props;
  const exportMode = config.prepaid_export_mode ?? "FULL";
  const servicesOnly = exportMode === "SERVICES_ONLY";
  return (
    <Column spacing={2}>
      <TextField
        select
        label="Guthabenbuchungen im Monatsabschluss"
        value={exportMode}
        disabled
        helperText={
          servicesOnly
            ? "Guthabenerwerb, Guthabenverwendung und deren Korrekturen werden ausgelassen. Leistungsbelege, tatsächliche Zahlungen und AUTOVIO-Gebühren bleiben enthalten."
            : "Schülerguthaben wird gemäß der hinterlegten Buchungsart berücksichtigt."
        }
      >
        {Object.entries(DATEV_PREPAID_EXPORT_LABELS).map(([id, label]) => (
          <MenuItem key={id} value={id}>
            {label}
          </MenuItem>
        ))}
      </TextField>
      {servicesOnly ? (
        <Alert severity="info">
          In diesem Modus gibt es keine Guthabenbuchungen und keinen Eröffnungsstapel für Schülerguthaben.
        </Alert>
      ) : (
        <>
          <TextField select label="Schülerguthaben" value={config.prepaid_accounting_mode ?? "LIABILITY"} disabled>
            {Object.entries(ACCOUNTING_LABELS).map(([id, label]) => (
              <MenuItem key={id} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Anfangsguthaben"
            value={config.prepaid_opening_balance_mode ?? "BLOCK"}
            disabled
            helperText="Die Übernahme einzelner Anfangsbestände muss durch AUTOVIO bestätigt werden. Bereits beim Steuerbüro gebuchte Bestände dürfen nicht erneut exportiert werden."
          >
            {Object.entries(OPENING_LABELS).map(([id, label]) => (
              <MenuItem key={id} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </>
      )}
      <Alert severity="info">
        Diese Einstellungen werden durch AUTOVIO eingerichtet. Ein Wechsel des Exportumfangs oder der
        Guthabenbuchungsart benötigt eine abgestimmte Bestandsübernahme und ist beim Speichern einer neuen
        Konfigurationsversion nicht möglich.
      </Alert>
    </Column>
  );
}
